// TODO(trevor) we should look into using an intersection observer
// TODO(trevor) we should probably base tacking off of the percentage of area on screen
export function isElementInViewport(element) {
    const rect = element.getBoundingClientRect();

    if (rect.top + rect.right + rect.bottom + rect.left === 0) {
        return false;
    }

    const html = document.documentElement;
    const viewport_width =  window.innerWidth || html.clientWidth;
    const viewport_height = window.innerHeight || html.clientHeight;

    return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= viewport_height &&
        rect.left <= viewport_width
    );
}

export function throttleInViewportUpdate(update) {
    let update_in_viewport_check_required = true;

    function flagInViewportUpdate(){
        update_in_viewport_check_required = true;
    }

    // TODO(trevor) passive events
    window.addEventListener("scroll", flagInViewportUpdate);
    window.addEventListener("resize", flagInViewportUpdate);
    window.addEventListener("mousemove", flagInViewportUpdate);
    window.addEventListener("mousedown", flagInViewportUpdate);
    window.addEventListener("mouseup", flagInViewportUpdate);

    setInterval(() => {
        if (update_in_viewport_check_required) {
            update_in_viewport_check_required = false;
            update();
        }
    }, 150);

    return flagInViewportUpdate;
}